import React, { useContext, useEffect, useState } from 'react';

import styled from 'styled-components';

import VideoPlayer from '../../Components/VideoPlayer';
import { StateContext } from '../../context/StateContex';
import { Button } from '../PepsiShutout/PepsiShutout.styles';

const VideoAdPage = () => {
  const [isButtonAllowed, setIsButtonAllowed] = useState<boolean>(false);
  const { isVideoAdPopupOpen, setIsVideoAdPopupOpen, setIsCongratsPopupOpen } =
    useContext(StateContext);
  const isDesktop = window.innerWidth > 768;

  const handleContinueClick = () => {
    setIsVideoAdPopupOpen(false);
  };

  useEffect(() => {
    setIsButtonAllowed(false);
    const timeout = setTimeout(() => {
      setIsButtonAllowed(true);
    }, 10000);
    return () => {
      clearTimeout(timeout);
    };
  }, [isVideoAdPopupOpen]);

  return isVideoAdPopupOpen ? (
    <VideoAdContainer>
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vw',
          }}
        >
          <span>
            {isDesktop ? (
              <VideoPlayer heightSize={'360'} widthSize={'640'} />
            ) : (
              <VideoPlayer heightSize={'240'} widthSize={'426'} />
            )}
          </span>
        </div>
        {isButtonAllowed && (
          <div style={{ position: 'absolute', bottom: '15vh' }}>
            <Button
              className={isButtonAllowed ? 'active' : 'inactive'}
              onClick={handleContinueClick}
            >
              Continue
            </Button>
          </div>
        )}
      </>
    </VideoAdContainer>
  ) : null;
};

export default VideoAdPage;

const VideoAdContainer = styled('div')({
  backgroundColor: '#000',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100vw',
  height: '100vh',
  zIndex: 200,
});
